import React from "react"
import { ShoppingCartIcon } from "@heroicons/react/24/outline"
import Button from "aldoo-ra/Button"
import useT from "../hooks/useT"

/**
 * Product page purchase pill: "[coin] 410 credits   Buy" (coins), or
 * "Free   Get", or an add-to-cart button for real-money products (dark by
 * default; `cartVariant` picks another Button variant). A discounted price
 * shows the price before the discount (`struck_price`), struck, before it.
 */
export default function ShopButton({ cost, real_price, struck_price, label, onClick, showCredits = true, showCartIcon = false, isOutOfStock = false, disabled = false, cartVariant = "primary_dark_l", className = "" }) {
  const t = useT()
  const creditsLabel = showCredits && !Number.isNaN(parseInt(cost)) ? t("%cost% credits", cost) : cost
  const struck = struck_price ? <span className="text-[14px] font-normal line-through opacity-70" data-testid="struck-price">{struck_price}</span> : null

  if (showCartIcon) {
    return (
      <Button variant={cartVariant} className={className} onClick={onClick} disabled={isOutOfStock || disabled}>
        {!isOutOfStock && struck}
        <span className="text-[18px] font-bold">{isOutOfStock ? t`Out of Stock` : showCredits ? creditsLabel : real_price}</span>
        {!isOutOfStock && <ShoppingCartIcon className="w-7 h-7" />}
      </Button>
    )
  }

  return (
    <Button variant="shop" className={className} onClick={onClick} disabled={disabled}>
      {showCredits && <img src="/static/p-images/coin--30x30.webp" alt="aldoo-credits" width={30} height={30} />}
      {struck && <span className={showCredits ? "" : "ml-4"}>{struck}</span>}
      <span className={`text-[18px] font-bold ${showCredits || struck ? "" : "ml-4"}`}>{showCredits ? creditsLabel : real_price}</span>
      <span className="ml-auto text-yellow1 font-bold">{label}</span>
    </Button>
  )
}
